import { supabase } from '../../lib/supabaseClient';

/**
 * Only leads nobody has decided on yet. If someone qualified a lead while it
 * sat ticked on the Triage tab, the bulk write skips it instead of
 * overwriting the qualification.
 */
const UNDECIDED_STAGES = ['new', 'spoken', 'callback_needed'];

/**
 * "Not a lead": hospitals, vendors, existing families, wrong numbers. The
 * same write as the Slack button (slack-interactions.service.ts), plus
 * disqualified_at like the lead page's Disqualify. Returns how many leads
 * changed.
 */
export async function markNotALead(leadIds: string[]): Promise<number> {
    const now = new Date().toISOString();
    return updateUndecided(leadIds, {
        stage: 'disqualified',
        qualification_status: 'unqualified',
        closed_lost_reason: 'not_a_lead',
        disqualified_at: now,
        updated_at: now,
    });
}

/** The lead page's Disqualify, for many leads with one reason. */
export async function disqualifyLeads(leadIds: string[], reason: string, notes: string): Promise<number> {
    const now = new Date().toISOString();
    return updateUndecided(leadIds, {
        stage: 'disqualified',
        qualification_status: 'unqualified',
        disqualified_reason: notes.trim() ? `${reason}: ${notes.trim()}` : reason,
        disqualified_at: now,
        updated_at: now,
    });
}

async function updateUndecided(leadIds: string[], patch: Record<string, unknown>): Promise<number> {
    if (leadIds.length === 0) return 0;
    const { data, error } = await supabase
        .from('leads')
        .update(patch)
        .in('id', leadIds)
        .in('stage', UNDECIDED_STAGES)
        .select('id');
    if (error) throw error;
    return data?.length ?? 0;
}
